import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthState } from './module/auth/state/auth.state';

import { LogoutReason, LogoutStatus, PROFET_APPS } from '@propmix/profet-common-header';
import { NewOrderState } from './module/new-order/state/new-order.state';
import { OrderLockService } from './module/order/service/order-lock.service';
import { AppPermission } from './shared/interface/common.interface';
import { UserRole } from './shared/interface/user.interface';
import { IconService } from './shared/services/icon.service';
import { CompanyState } from './shared/state/company.state';
import { SlidingSheetState } from './shared/state/sliding-sheet.state';
import { UserState } from './shared/state/user.state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  app = PROFET_APPS.appraisal_valuation;
  userRole = UserRole;
  permission = AppPermission;
  showAssist: boolean = true;

  constructor(
    public authState: AuthState,
    public userState: UserState,
    public slidingSheetState: SlidingSheetState,
    private _router: Router,
    private _newOrderState: NewOrderState,
    public companyState: CompanyState,
    private orderLockService: OrderLockService,
    private _iconService: IconService
  ) {}

  ngOnInit() {
    if (this.companyState.companySetting.showAppraisalAssist === false) {
      this.showAssist = false;
    }
  }

  createOrder() {
    this._newOrderState.newOrder = null;
    this._newOrderState.searchPropertyQuery = null;
    this._router.navigate(['/orders/new']);
  }

  handleLogout(event: { reason: LogoutReason; status: LogoutStatus } | void) {
    if (event?.status === LogoutStatus.INITIATED || event?.reason === LogoutReason.SESSION_TIMEOUT) {
      this.orderLockService.releaseLockOnLogout();
    }
  }
}
